module.exports = __webpack_public_path__ + "static/media/unfav-copy.39dea071.svg";